<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONVÊNIOS - Time Line</span>
                </h4>
                <app-tabela
                    :itens="convenios"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false">
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary mr-1">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="Detalhes(data.idConvenio)"
                            ></i>
                        </span>
                    </template>
                    <template slot="vigencia" slot-scope="data">
                        {{data.dtInicioVigencia ? $moment(data.dtInicioVigencia).format('DD/MM/YYYY') : ''}}
                        <span v-if="data.dtInicioVigencia">a</span>
                        {{data.dtFimVigencia ? $moment(data.dtFimVigencia).format('DD/MM/YYYY') : ''}}
                    </template>
                    <template slot="nuValorConvenio" slot-scope="data">
                        <span class="text-nowrap">{{data.nuValorConvenio | currency}}</span>
                    </template>
                </app-tabela>
            </b-card-body>
            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import ConveniosServicos from './ConveniosServicos'
export default {

    data() {
        return {
            convenios: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'vcCodigoEstruturado',
                    label: 'Convênio',
                    filterable: true,
                    sortable: true,
                },
                {
                    key: 'convenente',
                    label: 'Convenente',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'vcObjeto',
                    label: 'Objeto',
                    tdClass: 'colObjeto'
                },
                {
                    key: 'vigencia',
                    label: 'Vigência'
                },
                {
                    key: 'situacaoConvenio',
                    label: 'Situação',
                    filterable: true,
                    sortable: true
                }

            ],
            itensPorPagina: 5
        }
    },

    methods: {
        ListarConvenios() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ListarConvenios().then(response => {
                if (response) {
                    if (response.success) {
                        this.convenios = response.data;
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        Detalhes(id){
            this.$router.push({
                name: 'Convenios_Relatorios_Detalhes_TimeLine',
                params: {
                    idConvenio: id
                }
            })
        }
    },

    created() {
        this.ListarConvenios()
    },
}
</script>

